import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { Grid as i, Stack as t, Typography as n, Paper as o } from "@mui/material";
import { prettyDateRange as d } from "../../helpers/dates.js";
const g = ({ Body: l, Finish: h, Start: a, Staff: c }) => {
  const r = [];
  return c && c.length > 0 && r.push(/* @__PURE__ */ e(i, { size: { xs: 6, sm: 4 }, children: /* @__PURE__ */ s(t, { children: [
    /* @__PURE__ */ e(n, { variant: "caption", children: "Teacher" }),
    /* @__PURE__ */ e(n, { children: c.map((p) => p.DisplaynameSurname).join(", ") })
  ] }) }, 1)), a && h && r.push(/* @__PURE__ */ e(i, { size: { xs: 12, sm: 6 }, children: /* @__PURE__ */ s(t, { children: [
    /* @__PURE__ */ e(n, { variant: "caption", children: "When" }),
    /* @__PURE__ */ e(n, { children: d(a, h) })
  ] }) }, 2)), l && r.push(/* @__PURE__ */ e(i, { size: { xs: 12 }, children: /* @__PURE__ */ s(t, { children: [
    /* @__PURE__ */ e(n, { variant: "caption", children: "Notes" }),
    /* @__PURE__ */ e(n, { children: l })
  ] }) }, 3)), r.length === 0 ? null : /* @__PURE__ */ e(o, { sx: { p: 2 }, children: /* @__PURE__ */ e(i, { container: !0, spacing: 2, alignItems: "center", children: r }) });
};
export {
  g as ExcursionDetails
};
//# sourceMappingURL=ExcursionDetails.js.map
